import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export const passwordError = (err, fallback = 'Could not update password. Please try again.') => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || 'Invalid value').join('. ');
  return fallback;
};

export const PlatformPasswordFields = ({ form, setForm, currentLabel, busy }) => {
  const [visible, setVisible] = useState(false);
  const fields = [
    ...(currentLabel ? [['current', currentLabel, 'current-password', 'current']] : []),
    ['next', 'New password', 'new-password', 'new'],
    ['confirm', 'Confirm new password', 'new-password', 'confirm'],
  ];
  return <>
    {fields.map(([key, label, complete, id]) => <label className="pc-login-field" key={key}>{label}
      <input className="pc-input" type={visible ? 'text' : 'password'} required disabled={busy}
        minLength={key === 'current' ? undefined : 12} maxLength={128}
        value={form[key]} onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
        autoComplete={complete} data-testid={`pc-pw-${id}`} />
    </label>)}
    <button className="pc-btn pc-password-visibility" type="button" aria-pressed={visible}
      onClick={() => setVisible((v) => !v)} data-testid="pc-pw-visibility" title={visible ? 'Hide passwords' : 'Show passwords'}>
      {visible ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
      {visible ? 'Hide passwords' : 'Show passwords'}
    </button>
    <p className="pc-password-help" data-testid="pc-pw-policy">At least 12 characters, with uppercase, lowercase, a number and a symbol. Avoid your name or email. Maximum 72 UTF-8 bytes.</p>
  </>;
};